import { render, staticRenderFns } from "./groupForm.vue?vue&type=template&id=42422476&scoped=true&"
import script from "./groupForm.vue?vue&type=script&lang=js&"
export * from "./groupForm.vue?vue&type=script&lang=js&"
import style0 from "./groupForm.vue?vue&type=style&index=0&id=42422476&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42422476",
  null
  
)

export default component.exports